import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Select/select';
import { css } from '@patternfly/react-styles';
export var SelectGroup = function SelectGroup(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? [] : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$label = _a.label,
      label = _a$label === void 0 ? '' : _a$label,
      _a$titleId = _a.titleId,
      titleId = _a$titleId === void 0 ? '' : _a$titleId,
      props = __rest(_a, ["children", "className", "label", "titleId"]);

  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.selectMenuGroup, className)
  }), React.createElement("div", {
    className: css(styles.selectMenuGroupTitle),
    id: titleId,
    "aria-hidden": true
  }, label), children);
};